export const formatAddressFields = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;

  const parts = [
    value.address,
    value.city,
    value.state
  ].filter(Boolean);

  const base = parts.join(', ');
  return value.pincode ? `${base}${base ? ' - ' : ''}${value.pincode}` : base;
};

const getAddressSource = (address) => {
  if (!address) return {};
  if (typeof address === 'string') {
    return {
      address: '',
      city: '',
      state: '',
      pincode: '',
      country: '',
      fullAddress: address
    };
  }

  return {
    address: address.address || '',
    city: address.city || '',
    state: address.state || '',
    pincode: address.pincode || '',
    country: address.country || 'India',
    fullAddress: ''
  };
};

export const buildShippingSnapshot = ({
  customerName = '',
  address = null,
  addressId = '',
  contactName = '',
  contactPhone = '',
  contactEmail = ''
} = {}) => {
  const normalizedAddress = getAddressSource(address);
  const fullAddress = normalizedAddress.fullAddress || formatAddressFields(normalizedAddress);

  return {
    customerName: customerName || '',
    addressId: addressId || address?.id || '',
    contactName: contactName || address?.attention || '',
    contactPhone: contactPhone || address?.phone || '',
    contactEmail: contactEmail || address?.email || '',
    address: normalizedAddress.address || '',
    city: normalizedAddress.city || '',
    state: normalizedAddress.state || '',
    pincode: normalizedAddress.pincode || '',
    country: normalizedAddress.country || 'India',
    fullAddress
  };
};

export const getShippingSnapshotAddress = (snapshot, fallback = '') => {
  if (!snapshot) return fallback;
  return snapshot.fullAddress || formatAddressFields(snapshot) || fallback;
};

export const getSalesShippingSnapshot = (mocData = {}, orderData = null) => {
  if (mocData?.shippingSnapshot) {
    return buildShippingSnapshot(mocData.shippingSnapshot);
  }

  const orderShipping = orderData?.shippingAddress || null;
  return buildShippingSnapshot({
    customerName: mocData?.customerName || orderData?.customerName || '',
    address: mocData?.shippingAddress || orderShipping,
    addressId: orderShipping?.id || '',
    contactName: mocData?.shippingPersonName || orderShipping?.attention || '',
    contactPhone: mocData?.shippingPersonPhone || orderShipping?.phone || '',
    contactEmail: mocData?.shippingPersonEmail || orderShipping?.email || ''
  });
};
